import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'clsx';
import { LottiePlayer } from '@repo/design-system-kit';
import styles from './capital-deposit-in-progress.module.css';

export function CapitalDepositInProgress(): ReactNode {
  return (
    <div className={styles.content}>
      <LottiePlayer
        className={cx('mb-24', styles.icon)}
        data-test-lottie="true"
        path="/illustrations/lottie/success.json"
      />
      <h1 className="heading-section mb-16" data-test-capital-deposit-in-progress-title>
        <FormattedMessage id="congrats_title" />
      </h1>
      <p className="body-standard mb-16" data-test-capital-deposit-in-progress-paragraph1>
        <FormattedMessage
          id="congrats_desc_under_registration"
          values={{
            br: <br />,
          }}
        />
      </p>
      <p className="body-standard mb-40" data-test-capital-deposit-in-progress-paragraph2>
        <FormattedMessage id="continue_on_desktop_under_registration" />
      </p>
    </div>
  );
}
